/* Derived view-model for the record route.
 * GENERATED from the original artifact's vals_record() by
 * tools/convert-logic.py; edits since generation are tracked in git. */
import { FOOTER_COLS } from '@/data/wft';

export function recordVals() {
  return {
    footerCols: FOOTER_COLS,
    lifecycle: [
      {
        stage: 'Requested',
        dot: 'var(--wft-ink-3)',
        state: 'series + horizon fixed',
        body: 'A named series, a horizon and a transform. The inputs are recorded, not just the output.',
      },
      {
        stage: 'Written',
        dot: 'var(--wft-engine)',
        state: 'status: pending',
        body: 'Median, q20/q50/q80, baseline and decoder_name are stored before any outcome exists.',
      },
      {
        stage: 'Waiting',
        dot: 'var(--wft-delayed)',
        state: 'counted as pending',
        body: 'Pending forecasts are shown separately from resolved ones so the sample size is never inflated.',
      },
      {
        stage: 'Resolved',
        dot: 'var(--wft-live)',
        state: 'outcome attached',
        body: 'The realised value arrives from the same named source that produced the history.',
      },
      {
        stage: 'Scored',
        dot: 'var(--wft-accent)',
        state: 'in the ledger',
        body: 'Coverage, error and skill against the baseline are computed and kept — hit or miss.',
      },
    ],
    metrics: [
      {
        label: 'Resolved',
        body: 'Forecasts whose horizon has passed and which have been scored against a realised value.',
      },
      {
        label: 'Pending',
        body: 'Written down, outcome not yet known. Never mixed into the resolved count.',
      },
      {
        label: 'Coverage @80',
        body: 'Of resolved forecasts, the share whose outcome fell inside the 80% band. This is calibration, not accuracy.',
      },
      {
        label: 'Skill vs random walk',
        body: 'Error relative to the naive baseline. Zero means the engine added nothing at all.',
      },
      {
        label: 'Calibration curve',
        body: 'Predicted band against realised frequency, per quantile — the whole curve, not one point.',
      },
      {
        label: 'Skill by horizon',
        body: 'Where the engine helps and where it decays into the baseline. Published even where it is unflattering.',
      },
    ],
    rules: [
      {
        label: 'No re-scoring',
        body: 'Horizon and quantiles are fixed at write time; nothing is re-chosen once the outcome is known.',
      },
      {
        label: 'No survivorship',
        body: 'Misses stay in the ledger. A record that only keeps the good runs is marketing, not measurement.',
      },
      {
        label: 'Labelled provenance',
        body: 'Backtested numbers say so in the panel. Live numbers say when they started accumulating.',
      },
      {
        label: 'No line, no score',
        body: 'A fallback-decoder run is never drawn and never scored — it would credit the engine for a polyfit.',
      },
    ],
  };
}

export type RecordVals = ReturnType<typeof recordVals>;
